<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SalesFiltersCheckboxGroup from './SalesFiltersCheckboxGroup.vue';

const props = defineProps({
  activeList: { type: String, required: true },
  filters: { type: Object, required: true },
});

const emit = defineEmits(['toggle']);
const { t } = useI18n();
const delivered = computed(() => props.activeList === 'entregues');
const paymentOptions = computed(() => [
  { value: '1', label: t('SALES.FILTERS.PAYMENT_OPTIONS.CASH') },
  { value: '2', label: t('SALES.FILTERS.PAYMENT_OPTIONS.FINANCING') },
  { value: '3', label: t('SALES.FILTERS.PAYMENT_OPTIONS.FGTS') },
  { value: '4', label: t('SALES.FILTERS.PAYMENT_OPTIONS.CONSORTIUM') },
  { value: '5', label: t('SALES.FILTERS.PAYMENT_OPTIONS.INSTALLMENTS') },
  { value: '6', label: t('SALES.FILTERS.PAYMENT_OPTIONS.PIX') },
]);
const receiptOptions = computed(() => [
  { value: 'manual', label: t('SALES.FILTERS.RECEIPT_OPTIONS.MANUAL') },
  { value: 'docusign', label: t('SALES.FILTERS.RECEIPT_OPTIONS.DOCUSIGN') },
]);
const reviewOptions = computed(() => [
  { value: 'imovel', label: t('SALES.FILTERS.REVIEW_OPTIONS.PROPERTY') },
  { value: 'vendedor', label: t('SALES.FILTERS.REVIEW_OPTIONS.SELLER') },
  { value: 'comprador', label: t('SALES.FILTERS.REVIEW_OPTIONS.BUYER') },
  { value: 'recibo', label: t('SALES.FILTERS.REVIEW_OPTIONS.RECEIPT') },
]);
const toggle = (key, value) => emit('toggle', { key, value });
</script>

<template>
  <div
    class="mt-4 grid gap-4 border-t border-lais-border-soft pt-4 md:grid-cols-3"
  >
    <SalesFiltersCheckboxGroup
      v-if="delivered"
      compact
      :title="t('SALES.FILTERS.PAYMENT')"
      :options="paymentOptions"
      :values="filters.payment_method"
      @toggle="toggle('payment_method', $event)"
    />
    <SalesFiltersCheckboxGroup
      v-if="delivered"
      compact
      :title="t('SALES.FILTERS.RECEIPT')"
      :options="receiptOptions"
      :values="filters.receipt_type"
      @toggle="toggle('receipt_type', $event)"
    />
    <SalesFiltersCheckboxGroup
      v-if="activeList === 'revisoes'"
      compact
      :title="t('SALES.FILTERS.REVIEW')"
      :options="reviewOptions"
      :values="filters.review_section"
      @toggle="toggle('review_section', $event)"
    />
  </div>
</template>
